export enum TaskFilterType {
  CONSULTATION = 'AC',
  EXAM = 'AE',
  ATTENDANCE = 'AT',
  SERVICE = 'SE',
  SURGERY = 'AS',
}
